import React, { useState, useEffect } from "react";
import Header from "../components/Layout/Header";
import Admissions from "../components/Admissions-mainmenu/Admissions";
import Footer from "../components/Layout/Footer";
import { useDispatch, useSelector } from "react-redux";
import gsap from "gsap";
import { PageOpeningAnimation } from "../common/pageOpeningAnimation";
import Loading from "../common/Loading";
import { AdmissionsActions } from "../Store/Admissions/action";

function AdmissionMainmenu() {
  document.title = "Admissions  | PSG-IAP";
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    dispatch({ type: AdmissionsActions.GET_ADMISSIONS });
  }, [dispatch]);

  const { AdmissionsData } = useSelector((state) => state?.AdmissionsReducer);

  useEffect(() => {
    if (AdmissionsData?.length !== 0) {
      setLoading(false);
    } else {
      setLoading(false);
    }
  }, [AdmissionsData]);

  //for page opening animations
  useEffect(() => {
    if (!loading) {
      const svg = document.getElementById("svg");
      const tl = gsap.timeline({ repeat: 0, yoyo: true });

      tl.to(".bluee", {
        duration: 1,
        attr: { d: "M0 502S175 272 500 272s500 230 500 230V0H0Z" },
        ease: "power2.in",
      }).to(".bluee", {
        duration: 1,
        attr: { d: "M0 2S175 1 500 1s500 1 500 1V0H0Z" },
        ease: "power2.out",
      });

      // Start SVG animation after the loading text is hidden
      tl.add(() => {
        gsap.to(svg, {
          duration: 0.8,
          attr: { d: "M0 502S175 272 500 272s500 230 500 230V0H0Z" },
          ease: "power2.in",
        });
      });

      // Clean up animation on unmount
      return () => {
        tl.kill(); // Kill the animation to prevent memory leaks
      };
    }
  }, [loading]);

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <>
          <PageOpeningAnimation />
          <Header />
          <Admissions />
          <Footer />
        </>
      )}
    </div>
  );
}

export default AdmissionMainmenu;
